<template>
	<div class="container-fluid">

		<toolbar>
			<h2>Dashboard</h2>

			<div class="controls">
				<template v-if="editMode">
					<button class="btn btn-light" v-on:click="openAddWidgetModal(false)">
						<i class="fa fa-plus"></i>
						Add Widget
					</button>

					<button class="btn btn-light" v-on:click="resetDefaultWidgets">
						<i class="fa fa-sync"></i>
						Reset Default Layout
					</button>
				</template>

				<button class="btn" :class="{'btn-light' : !editMode, 'btn-success': editMode}" :title="!editMode ? 'Customize dashboard layout' : 'Done customizing'" v-on:click="editMode = !editMode">
					<i class="fa" :class="{'fa-cog':!editMode, 'fa-check': editMode}"></i>
				</button>
			</div>
		</toolbar>

		<draggable v-if="!editMode" 
			v-model="filteredWidgets" 
			element="div" 
			class="row"
			handle="h2.widget-header" 
			v-on:end="saveWidgets">

			<div v-for="block in filteredWidgets"
				v-if="block.used"
				:class="{
					'col-xl-3 col-lg-6': block.size == 'sm',
					'col-xl-6 col-lg-12': block.size == 'lg',
					'standard-widget-height': block.container
				}">

				<component v-if="!('container' in block) && block.name != 'AddonAppWidget'" 
					:is="block.name" 
					class="standard-widget-height" 
					max-height="350px"
					v-on:hideWidget="removeWidget(block)">		
				</component>

				<addon-app-widget v-else-if="!('container' in block)" 
					class="standard-widget-height"
					:app="block.app">
				</addon-app-widget>

				<template v-else>
					<div v-for="widget in block.widgets" v-if="!('used' in widget) || widget.used">
						<component v-if="widget.name != 'AddonAppWidget' && systemWidgetsAvailable.indexOf(widget.name) >= 0" 
							:key="widget.name" 
							:is="widget.name" 
							class="standard-widget-height-half" 
							max-height="192px"
							v-on:hideWidget="removeWidget(widget,block)">		
						</component>

						<addon-app-widget v-else
							class="standard-widget-height-half"
							:app="widget.app">
						</addon-app-widget>

					</div>
				</template>
			</div>
		</draggable>

		<div v-if="editMode">
			<p>
				<h3>Instructions</h3>
				<ol>
					<li>Re-order your widgets by clicking the <i class="fa fa-arrows-alt-h"></i> and dragging to where you want</li>
					<li>Remove the widget from the dashboard by clicking the <i class="fa fa-times"></i> button</li>
					<li>Re-size the widget by clicking the "Larger" or "Smaller" buttons</li>
				</ol>
			</p>

			<draggable 
				v-model="filteredWidgets" 
				element="div" 
				class="row" 
				handle="h2.widget-header"
				v-on:end="saveWidgets">

				<div v-for="block in filteredWidgets"
					v-if="block.used"
					:class="{
						'col-xl-3 col-lg-6': block.size == 'sm',
						'col-xl-6 col-lg-12': block.size == 'lg',
						'standard-widget-height': block.container,
						'is-container': block.container
					}">

					<div v-if="block.container" class="mb-2">
						<h2 class="widget-header" style="display: inline-block;margin: 0;padding: 0;margin-top: -10px"><i class="fa fa-arrows-alt-h icon-button"></i></h2>
						<i class="fa fa-times icon-button float-right" v-on:click="removeWidget(block)"></i>
					
						<div style="clear: both;"></div>

						<!--<button class="btn btn-light btn-lg">
							<i class="fa fa-arrow-left"></i> Larger <i class="fa fa-arrow-right"></i>
						</button>

						<button class="btn btn-light btn-lg">
							<i class="fa fa-arrow-right"></i> Smaller <i class="fa fa-arrow-left"></i>
						</button>-->

						<div class="size-selector">
							<button class="size-selector-button" v-if="block.size == 'sm'" v-on:click="setWidgetSize(block,'lg')">
								<div class="button-label">Larger</div>
								<div class="d-flex flex-row">
									<div class="widget-box for-container widget-box-large widget-box-highlighted"></div>
									<div class="widget-box for-container"></div>
									<div class="widget-box for-container"></div>
								</div>
							</button>
							<button class="size-selector-button" v-else v-on:click="setWidgetSize(block,'sm')">
								<div class="button-label">Smaller</div>
								<div class="d-flex flex-row">
									<div class="widget-box for-container widget-box-small widget-box-highlighted"></div>
									<div class="widget-box for-container"></div>
									<div class="widget-box for-container"></div>
									<div class="widget-box for-container"></div>
								</div>
							</button>
						</div>
					</div>

					<component v-if="!('container' in block)" 
						is="widget" 
						:title="block.label" 
						class="standard-widget-height" 
						header-button="fa-times"
						icon="fa-arrows-alt-h"
						v-on:headerButtonClick="removeWidget(block)"
						max-height="400px">	

						<!--<div class="d-flex align-items-center justify-content-center">
							<button class="btn btn-light btn-lg">
								<i class="fa fa-arrow-left"></i> Larger <i class="fa fa-arrow-right"></i>
							</button>

							<button class="btn btn-light btn-lg">
								<i class="fa fa-arrow-right"></i> Smaller <i class="fa fa-arrow-left"></i>
							</button>
						</div>-->

						<div class="size-selector">
							<button class="size-selector-button" v-if="block.size == 'sm'" v-on:click="setWidgetSize(block,'lg')">
								<div class="button-label">Larger</div>
								<div class="d-flex flex-row">
									<div class="widget-box widget-box-large widget-box-highlighted"></div>
									<div class="widget-box"></div>
									<div class="widget-box"></div>
								</div>
							</button>
							<button class="size-selector-button" v-else v-on:click="setWidgetSize(block,'sm')">
								<div class="button-label">Smaller</div>
								<div class="d-flex flex-row">
									<div class="widget-box widget-box-small widget-box-highlighted"></div>
									<div class="widget-box"></div>
									<div class="widget-box"></div>
									<div class="widget-box"></div>
								</div>
							</button>
						</div>

					</component>

					<template v-else>
						<div v-for="(widget,index) in filterWidgetsforPerms(block.widgets)" v-if="!('used' in widget) || widget.used">
							<component :key="widget.name" 
								:title="widget.label" 
								is="widget" 
								class="standard-widget-height-half" 
								header-button="fa-times"
								v-on:headerButtonClick="removeWidget(widget,block)"
								max-height="192px">		
							</component>
						</div>
					</template>

					<div v-if="block.container && block.widgets.length == 1" 
						class="empty-widget-placeholder standard-widget-height-half" 
						v-on:click="openAddWidgetModal(block)">

						<i class="fa fa-plus fa-2x icon-button"></i>
						<div>Add Widget</div>
					</div>
					<div v-if="block.container && block.widgets.length == 0" 
						class="empty-widget-placeholder standard-widget-height-half" 
						v-on:click="openAddWidgetModal(block)">

						<i class="fa fa-plus fa-2x icon-button"></i>
						<div>Add Widget</div>
					</div>

				</div>
			</draggable>
		</div>

		<modal-dialog
			:modal-visible="onboardingModal.visible"
			:title="'Welcome to '+$store.appName"
			:submit-visible="false"
			cancel-button-text="Ok, Done"
			v-on:closeModal="finishOnboarding">

			<div class="alert alert-info">

				<h2>Congratulations, you're done!</h2>

				<p>Your account is now ready to go. You have now been directed to your main Dashboard page, where you can get a quick look at relevant information</p>

				<p>You can navigate around {{$store.appName}} by using the pull-out menu button (<i class="fa fa-navicon"></i>) on the top left.</p>

				<p>You can also clock in to projects, log an expense, view your profile, or access your messages by using the top menu.</p>
			</div>
		</modal-dialog>

		<modal-dialog :modal-visible="addWidgetModal.visible"
			v-on:closeModal="addWidgetModal.visible = false"
			title="Add Widget"
			:submit-visible="false"
			cancel-button-text="Done">

			<h2>Un-used Widgets</h2>

			<div v-for="handle in getFlatWidgetList(true,permFilteredWidgets)" v-if="!handle.used" class="widget-handle unused text-center lg">

				<h3>{{handle.label}}</h3>

				<button class="btn btn-light" v-on:click="addWidget(handle)">
					<i class="fa fa-plus"></i>
					Add to Dashboard
				</button>
			</div>
			<p v-if="getFlatWidgetList(true,permFilteredWidgets).filter(wid => !wid.used).length == 0">You're using all available widgets</p>

			<div class="mt-2" v-if="!addWidgetModal.container">
				<div class="widget-handle unused text-center lg">
					<button class="btn btn-light" v-on:click="addContainer">
						<i class="fa fa-plus"></i>
						Add Container<br>
						<small>A container can hold up to 2 widgets stacked vertically</small>
					</button>
				</div>
			</div>

		</modal-dialog>
		
	</div>
</template>

<script>
import Toolbar from "../layout_fragments/Toolbar"

import EmployeeSearchWidget from "@/components/widgets/EmployeeSearchWidget"

import UniversalSearchWidget from "@/components/widgets/UniversalSearchWidget"
import AddonAppWidget from "@/components/widgets/AddonAppWidget"
import Widget from "@/components/Widget"

import ReviewItemsWidget from "@/components/widgets/ReviewItemsWidget"
import MyProjectsWidget from "@/components/widgets/MyProjectsWidget"
import MyServicesWidget from "@/components/widgets/MyServicesWidget"
import CalendarWidget from "@/components/widgets/CalendarWidget"
import MessagesWidget from "@/components/widgets/MessagesWidget"
import SetupProgressWidget from "@/components/widgets/SetupProgressWidget"
import NewsWidget from "@/components/widgets/NewsWidget"

import draggable from 'vuedraggable'

import ModalDialog from "../components/ModalDialog"
import Field from "@/components/Field"

export default {

	name: 'AppHome',
	components: {
		Toolbar,
		EmployeeSearchWidget,
		UniversalSearchWidget,
		ReviewItemsWidget,
		MyProjectsWidget,
		MyServicesWidget,
		CalendarWidget,
		MessagesWidget,
		SetupProgressWidget,
		NewsWidget,
		ModalDialog,
		Field,
		draggable,
		AddonAppWidget,
		Widget
	},
	data() {
		return {
			//widgets must be registered here so we know not to load any old ones that aren't in the codebase anymore
			systemWidgetsAvailable: [
				"EmployeeSearchWidget",
				"UniversalSearchWidget",
				"ReviewItemsWidget",
				"MyProjectsWidget",
				"MyServicesWidget",
				"CalendarWidget",
				//"MessagesWidget",
				"SetupProgressWidget",
				"NewsWidget",
			],
			widgets: [],
			filteredWidgets: [],
			usedWidgets: [],
			editMode: false,
			defaultWidgets: [
				{
					name: "SetupProgressWidget",
					label: "Setup Progress",
					used: true,
					size: "sm", //sm (half width), lg (full width)
					roleType: "Admin"
				},
				{
					name: "ReviewItemsWidget",
					label: "Review Items",
					used: true,
					size: "sm" //sm (half width), lg (full width)
				},
				{
					name: "CalendarWidget",
					label: "Calendar",
					used: true,
					size: "lg" //sm (half width), lg (full width)
				},
				{
					name: "NewsWidget",
					label: "Current News",
					used: true,
					size: "lg" //sm (half width), lg (full width)
				},
				/*
				{
					name: "MessagesWidget",
					label: "Messages",
					used: true,
					size: "sm" //sm (half width), lg (full width)
				},
				*/
				{
					container: true,
					size: 'sm',
					used:true,
					widgets: [
						
						{
							name: "MyServicesWidget",
							label: "My Services",
							used: true,
							size: "sm" //sm (half width), lg (full width)
						},
						{
							name: "MyProjectsWidget",
							label: "My Projects",
							used: true,
							size: "sm" //sm (half width), lg (full width)
						}
					]
				},
				{
					name: "UniversalSearchWidget",
					label: "Universal Search",
					used: true,
					size: "lg" //sm (half width), lg (full width)
				}
			],
			addWidgetModal: {
				visible: false,
				container: null
			},
			customizeWidgetModalVisible: false,
			onboardingModal: {
				visible: false,
			}
		}
	},
	watch: {
		'$store.userDetails'() {
			this.setWidgetSettings()
		}
	},
	computed: {
		permFilteredWidgets() {
			let vm = this

			return this.filterWidgetsforPerms(this.widgets)
		},
		widgetOptions() {
			return this.optionify(this.widgets.filter(block => !('container' in block)),"label")
		}
	},
	methods: {
		filterWidgetsforPerms(widgets) {
			let vm = this
			let filtered = widgets.filter(widget => {
				if ("roleType" in widget && widget.roleType == 'Admin') {
					if (vm.getUserRoleType() == "Admin")
						return true
					else
						return false
				}

				return true
			}).filter(widget => this.systemWidgetsAvailable.indexOf(widget.name) >= 0 || widget.container)

			return filtered
		},
		openAddWidgetModal(container) {
			this.addWidgetModal.visible = true
			this.addWidgetModal.container = container
		},
		addWidget(widget) {
			widget.used = true

			if (this.addWidgetModal.container) {
				//remove from main container and add to the container
				let index = this.widgets.findIndex(wid => wid.name == widget.name)

				this.widgets.splice(index,1)
				this.addWidgetModal.container.widgets.push(widget)
			}
			this.saveWidgets()
		},
		removeWidget(widget,container) {
			let vm = this
			widget.used = false

			if ('widgets' in widget && widget.widgets.length > 0) {
				//move contained widgets back to main container
				widget.widgets.forEach(innerWidget => {
					innerWidget.used = false
					vm.widgets.push(innerWidget)
				})
				widget.widgets = []
			}

			//move it back to main container
			if (container) {
				let index = container.widgets.findIndex(wid => wid.name == widget.name)
				container.widgets.splice(index,1)
				this.widgets.push(widget)
			}

			this.saveWidgets()
		},
		setWidgetSize(block,size) {
			block.size = size
			this.saveWidgets()
		},
		getUsedWidgets(widgets) {
			let vm = this

			let widgetList = this.getFlatWidgetList()

			return this.permFilteredWidgets.filter(widget => {
				
				if (widget.used) {
					if ("container" in widget && widget.container) {
						return true
					}
					else if (widgetList.indexOf(widget.name) >= 0)
						return true
				}

				return false
			})
		},
		getFlatWidgetList(fullObj,widgetSource) {
			let vm = this

			if (!widgetSource)
				widgetSource = this.defaultWidgets

			//check that all the widgets are included somewhere
			let widgetList = []
			widgetSource.forEach(widgetOrContainer => {
				if (!widgetList.find(widgetInList => widgetInList == widgetOrContainer.name) && "name" in widgetOrContainer) {
					if (fullObj)
						widgetList.push(widgetOrContainer)
					else
						widgetList.push(widgetOrContainer.name)
				}

				if ("widgets" in widgetOrContainer) {
					widgetOrContainer.widgets.forEach(subWidget => {
						if (!widgetList.find(widgetInList => widgetInList == subWidget.name)) {
							if (fullObj)
								widgetList.push(subWidget)
							else
								widgetList.push(subWidget.name)
						}
					})
				}
			})

			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp) {
				let dashboardApps = this.$store.company.AddonApp.filter(app => app.ui_location == "Dashboard Widget")

				dashboardApps.forEach(app => {

					if (fullObj) {
						widgetList.push({
							name: "AddonAppWidget",
							label: app.app_name,
							used: true,
							size: "sm",
							app: vm.cloneObj(app)
						})
					}
					else
						widgetList.push(app.app_name)
				})
			}

			return widgetList
		},
		resetDefaultWidgets() {
			this.widgets = JSON.parse(JSON.stringify(this.defaultWidgets))
			this.saveWidgets()
		},
		addContainer() {
			this.widgets.push({
				container: true,
				size: 'sm',
				used:true,
				widgets: []
			})

			this.alertSuccess("A Container has been added to the bottom of your dashboard")
		},
		saveWidgets(arg) {
			let vm = this

			this.getJSON("User/find/"+this.$store.userDetails.slug).then(response => {
				let widgetSettings = {}

				try {
					widgetSettings = JSON.parse(response.data.widget_settings_json)
				}
				catch (e) {}

				widgetSettings.main = vm.filteredWidgets

				let payload = {
					id: vm.$store.userDetails.id,
					widget_settings_json: JSON.stringify(widgetSettings)
				}

				vm.postData("User/save",payload).then(response => {
					if (response.success) {
						//vm.alertSaved("Dashboard layout saved!")

						vm.$store.userDetails.widget_settings_json = JSON.stringify(widgetSettings)
						localStorage.userDetails = JSON.stringify(vm.$store.userDetails)

						vm.usedWidgets = vm.getUsedWidgets(vm.widgets)
					}
				})
			})
		},
		setWidgetSettings() {
			let vm = this

			this.widgets = JSON.parse(JSON.stringify(this.defaultWidgets))

			try {
				let settings = JSON.parse(this.$store.userDetails.widget_settings_json)
				this.widgets = settings.main
			}
			catch (e) {}

			//filter out undefined widgets: this may include widgets stored in the user's settings that don't actually exist anymore
			/*
			Doesn't work, need another way
			this.widgets = this.widgets.filter(widget => {
				return typeof window[widget.name] != 'undefined'
			})
			*/

			//check if any widgets in default list are not present in either used, or unused lists
			let fullWidgetObjs = this.getFlatWidgetList(true)

			fullWidgetObjs.forEach(widgetInList => {
				let found = vm.widgets.find(userWidget => {
					if ("name" in userWidget && userWidget.name == widgetInList.name)
						return userWidget

					else if ("widgets" in userWidget) {
						let widget = userWidget.widgets.find(subWidget => subWidget.name == widgetInList.name)
						if (widget)
							return widget
					}
					return false
				})

				if (!found) {
					widgetInList.used = true
					vm.widgets.push(widgetInList)
				} 
			})

			vm.usedWidgets = vm.getUsedWidgets(vm.widgets)

			vm.filteredWidgets = vm.filterWidgetsforPerms(vm.widgets)

		},
		finishOnboarding() {
			this.onboardingModal.visible = false
			this.$store.accountSetupMode = false
		}
	},
	created() {
		this.setWidgetSettings()

		if (this.$store.accountSetupMode)
			this.onboardingModal.visible = true
	}

}
</script>

<style>

	.container-fluid {
		background-color: var(--background-light);
	}

	h2 {
		font-size: 20pt;
		color: #455A64 
	}

	.col-xl-3,
	.col-xl-6 {
		padding-left: 10px;
		padding-right: 10px;
	}

	.standard-widget-height {
		height: 400px;
		margin-bottom: 20px!important;
	}

	.standard-widget-height-half {
		height: 190px;
		margin-bottom: 20px!important;
	}

	.is-container {
		border: 1px solid #404040;
		background-color: #e0e0e0;
		padding: 10px;
		position: relative;
		width: calc(100% - 20px);
		margin-bottom: 20px;
	}

	.is-container .standard-widget-height-half {
		height: 137px;
	}

	.card .card-header h3 {
		margin: 0;
		text-decoration: none;
	}

	.widget-handles {
		display: flex;
    	flex-wrap: wrap;
	}

	.widget-handle {
		display: inline-block;
		border: 1px solid #404040;
		background-color: #e0e0e0;
		padding-top: 10px;
		padding-bottom: 10px;
		position: relative;
	}

	.widget-handle.used {
		cursor: pointer;
	}

	.widget-handle.used:hover {
		background-color: #f1eadc;
	}

	.widget-handle .icon-button {
		position: absolute;
		top: 5px;
		right: 5px;
	}

	.widget-handle.sm {
		width: 25%;
	}

	.widget-handle.lg {
		width: 100%;
	}

	.empty-widget-placeholder {
		width: 100%;
		border: 1px dashed #404040;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.empty-widget-placeholder:hover {
		background-color: rgba(0,0,0,0.1);
		cursor: pointer;
	}

	.container-draggable {
		min-height: 100px;
		border: 1px solid #404040;
		margin: 10px;
		margin-bottom: 0;
	}

	.container-draggable .widget-handle {
		width: 100%;
	}

	.size-selector .size-selector-button {
		border: 1px solid #a0a0a0;
		width: 100%;
		background: white;
		padding: 0;
		position: relative;
	}

	.size-selector .size-selector-button .button-label {
		position: absolute;
		z-index: 2;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18pt;
		color: #636363;
		cursor: pointer;
	}

	.size-selector .size-selector-button .button-label:hover {
		background-color: rgba(0,0,0,0.1);
	}

	.size-selector .widget-box {
		height: 100px;
		border: 1px solid #a0a0a0;
		background-color: #e0e0e0;
		width: 25%;
	}

	.size-selector .widget-box.for-container {
		height: 40px;
	}

	.size-selector .widget-box-highlighted {
		border-color: red;
		background-color: #f3cdd0
	}

	.size-selector .widget-box-small {
		width: 25%;
	}

	.size-selector .widget-box-large {
		width: 50%;
	}

	@media (max-width: 991px) {

	}
</style>
